var $headerSubscription = $('#header-subscription');
var $headerSubscriptionToggle = $('#header-subscription-toggle');

$(document).on('keyup', function(e) {
    if ($headerSubscription.is(':visible') && e.keyCode == 27) {
        $headerSubscription.slideUp(200);
        $headerSubscriptionToggle.removeClass('is-open');
        $headerSubscriptionToggle.find('> span').text('Подписка');
    }
    return false;
});

$headerSubscriptionToggle.on('click', function() {
    var $this = $(this);
    $this.toggleClass('is-open');
    $this.find('> span').toggleText('Подписка', 'Закрыть');
    $headerSubscription.slideToggle(200);
    return false;
});